<template>
  <div :class="['kiosk-spinner', $style.root]" data-testid="overlay-loading" />
</template>

<script setup lang="ts">
</script>

<style module>
.root:global(.kiosk-spinner) {
  --kiosk-spinner-size: 1.67rem;
  --kiosk-spinner-color: var(--Kiosk--font_color);
  --kiosk-spinner-opacity: 0.5;
  --kiosk-spinner-thinkness: 0.2;

  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
</style>
